import z from 'zod';
import { SendApplicationFormTemplates } from './types';
import { SendOcaLinkSendMethods } from '@trnsact/trnsact-shared-types';

const contactDetailsSchema = z.object({
  contactDetails: z.object({
    businessName: z.string().optional(),
    lastName: z.string().min(1, 'Last name is required'),
    firstName: z.string().min(1, 'First name is required'),
    email: z.string().email('Invalid email address').optional().or(z.literal('')),
    mobilePhone: z.string().length(14, 'Invalid phone number').optional().or(z.literal('')),
  }),
});

const financeSchema = z.object({
  finance: z.object({
    term: z.string(),
    rate: z.number().nullable(),
    downPayment: z.number().nullable(),
  }),
});

const equipmentSchema = z.object({
  equipment: z
    .object({
      year: z.string().optional(),
      make: z.string().optional(),
      model: z.string().optional(),
      mileage: z.number().optional(),
      quantity: z.number().optional(),
      serialVin: z.string().optional(),
      condition: z.string().optional(),
      description: z.string().optional(),
      stockNumber: z.string().optional(),
      amountRequested: z.number().optional(),
    })
    .optional(),
});

export const sendApplicationFormSchema = z
  .object({
    sendMethod: z.nativeEnum(SendOcaLinkSendMethods, {
      required_error: 'Please select a send method',
    }),
    creditApplicationTemplate: z.nativeEnum(SendApplicationFormTemplates, {
      required_error: 'Please select a credit template',
    }),
    isPromoteFlyer: z.boolean(),
    lenderProfileId: z.string().optional(),
    listOfInventory: z.array(z.string().uuid()),
  })
  .and(contactDetailsSchema)
  .and(financeSchema)
  .and(equipmentSchema)
  .superRefine((data, ctx) => {
    const isMobileRequired = [SendOcaLinkSendMethods.Text, SendOcaLinkSendMethods.TextAndEmail].includes(
      data.sendMethod
    );
    if (isMobileRequired && !data.contactDetails.mobilePhone) {
      ctx.addIssue({
        path: ['contactDetails', 'mobilePhone'],
        code: z.ZodIssueCode.custom,
        message: 'Mobile phone is required when sending by text or text and email',
      });
    }

    const isEmailRequired = [SendOcaLinkSendMethods.Email, SendOcaLinkSendMethods.TextAndEmail].includes(
      data.sendMethod
    );
    if (isEmailRequired && !data.contactDetails.email) {
      ctx.addIssue({
        path: ['contactDetails', 'email'],
        code: z.ZodIssueCode.custom,
        message: 'Email is required when sending by email or text and email',
      });
    }

    if (data.creditApplicationTemplate === SendApplicationFormTemplates.Lender && !data.lenderProfileId) {
      ctx.addIssue({
        path: ['lenderProfileId'],
        code: z.ZodIssueCode.custom,
        message: 'Select Lender Credit Application Template',
      });
    }
  });
